import initializeVue from "../../shared/initialize-vue";
import componentContext from "../component-context";

export default function(selector) {
  return initializeVue(selector, componentContext);
}
